// Full-screen brand loader, shown while the session is resolving.
export function FullScreenLoader() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-ele-bg text-ele-body">
      <div className="font-heading text-2xl tracking-wide">
        East London <span className="text-ele-green">Elevators</span>
        <span className="ml-2 animate-pulse">...</span>
      </div>
    </div>
  );
}

// The office Loader (Session AUJ, design system Session 2, spec 3.5). It adds NO new visual: the
// portal's "Loader" is FullScreenLoader above plus the shared Skeleton shapes, which the office
// already used in 23 files. What the office lacked was the WRAPPER: QuotesPage wrapped its skeleton
// in role="status" with an sr-only label, AccidentsPage did not, and 154 places printed a bare
// "Loading...". This is that wrapper.
//
// The default label is EXACTLY "Loading..." (sr-only text in the DOM), so the many tests that query
// getByText("Loading...") keep passing through a migration. A label naming the thing ("Loading the
// quotes...") is encouraged but optional.
//   rows   -> a list or table placeholder (SkeletonRows)
//   panel  -> a card or detail section (SkeletonPanel)
//   inline -> a 12px shimmer bar for a value inside a sentence or a small panel
import { SkeletonPanel, SkeletonRows } from "./Skeleton";

export interface LoaderProps {
  label?: string;
  shape?: "rows" | "panel" | "inline";
  rows?: number;
  className?: string;
}

export function Loader({ label = "Loading...", shape = "rows", rows = 6, className = "" }: LoaderProps) {
  return (
    <div role="status" aria-live="polite" className={className || undefined}>
      <span className="sr-only">{label}</span>
      {shape === "rows" && <SkeletonRows rows={rows} />}
      {shape === "panel" && <SkeletonPanel />}
      {shape === "inline" && <div aria-hidden className="ele-shimmer inline-block h-3 w-24 rounded bg-ele-inset-strong align-middle" />}
    </div>
  );
}
